import React from 'react'
import { useRouteMatch } from 'react-router-dom'

import { useGetIdentifiers } from '../../../hooks/useGetIdentifiers'
import { MobileHeader } from './MobileHeader'
import { useForDesktop } from '@sketch/components'

export const Header: React.FC = () => {
  const { path } = useRouteMatch()
  const { shareIdentifier } = useGetIdentifiers()
  const isDesktopAndBigger = useForDesktop()

  if (!isDesktopAndBigger) {
    return <MobileHeader shareID={shareIdentifier} path={path} />
  }

  return null
}
